import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * Modal for confirming API operations
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether the modal is visible
 * @param {Function} props.onHide - Function to call when modal is closed
 * @param {Function} props.onConfirm - Function to call when operation is confirmed
 * @param {Object} props.endpoint - The endpoint to execute
 * @param {string} props.baseUrl - The API base URL
 * @returns {JSX.Element}
 */
const ConfirmationModal = ({ show, onHide, onConfirm, endpoint, baseUrl }) => {
  const isDeleteOperation = endpoint?.method === "DELETE";

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{isDeleteOperation ? "Confirm Delete Operation" : "Production API Call Confirmation"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isDeleteOperation ? (
          <>
            <p className="text-danger">
              <strong>Warning:</strong> You are about to perform a DELETE operation.
            </p>
            <p>
              Endpoint:{" "}
              <code>
                {baseUrl}
                {endpoint?.path}
              </code>
            </p>
            <p>This will permanently remove data and cannot be undone.</p>
            <p>Are you sure you want to proceed with this deletion?</p>
          </>
        ) : (
          <>
            <p>
              You are about to make a <strong>{endpoint?.method}</strong> request to a production API:
            </p>
            <p>
              <code>
                {baseUrl}
                {endpoint?.path}
              </code>
            </p>
            <p className="text-danger">
              This operation could modify or delete data on your production server. Are you sure you want to proceed?
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant={isDeleteOperation ? "danger" : "warning"} onClick={onConfirm}>
          {isDeleteOperation ? "Yes, Delete" : "Yes, I understand the consequences"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
